export const ROUTES = {
    HOMEPAGE_ROUTE: "/",
    ARTICLEPAGE_ROUTE: "/articles",
    PODCASTPAGE_ROUTE: "/podcast",
    VOICEPAGE_ROUTE: "/voice",
    
    ABOUTPAGE_ROUTE: "/about",
    DASHBOARDPAGE_ROUTE: "/dashboard",
  
    USERSPAGE_ROUTE: "/users",
    USERPAGE_ROUTE: "/user",
  
    TRANSPAGE_ROUTE: "/trans", // list of transactions
    TRANPAGE_ROUTE: "/tran",   // add a transaction
  } as const;
  